// Libraries
import React from "react";
import PropTypes from "prop-types";

// Styles
import { CampaignsContainer, CampaignLink, CampaignArrow } from "./styles";

const Campaigns = ({ campaignLinkPrefix, campaigns, saveScroll }) => {
    // if no campaigns, return empty component so we dont need a flag in the parent component:
    if (!campaigns || (Array.isArray(campaigns) && campaigns.length === 0)) {
        return null;
    }

    return (
        <CampaignsContainer>
            {campaigns.map(({ title, url, showLink }) => {
                return (
                    showLink && (
                        <div key={title}>
                            <CampaignLink
                                onClick={() => saveScroll(0)}
                                to={url}
                            >
                                {campaignLinkPrefix} {title}
                            </CampaignLink>
                            <CampaignArrow />
                        </div>
                    )
                );
            })}
        </CampaignsContainer>
    );
};

Campaigns.propTypes = {
    campaignLinkPrefix: PropTypes.string,
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            showLink: PropTypes.bool.isRequired
        })
    ),
    saveScroll: PropTypes.func
};

export default Campaigns;
